import KendoUploadMixin from './KendoUploadMixin'

export default {
    name: 'kendo-upload',
    mixins: [ KendoUploadMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/index.js